<template lang="pug">
  include /mixins
  +b.modal-wrapper
    +b.close-popup.mdi.mdi-close.BUTTON(
      @click.prevent='$emit("close")'
    )
    +e.icon-wrapper
      +e.IMG.icon(:src="'/static/img/checkmark.svg'")
    +e.title.P {{ message.title }}
    +e.button
      +b.g-row.--justify_center
        +b.g-cell.g-cols--12.--narrow-sm
          +b.A.tt-button.--bordered_grey-v2(
            @click.prevent="$emit('close')"
          )
            +e.SPAN.title {{ _("Закрыть") }}
</template>

<script>
export default {
  props: {
    message: {
      type: Object,
    },
  },
}
</script>
